import * as React from 'react';
import { compKey } from './key';
import { namespacedClassnames } from '../../common';
import { InfoTooltip } from '../../primitives/info-tooltip/info-tooltip';
import { Toggle } from '../../primitives/toggle/toggle';
import { Text } from '../../new-libby/core/typography';
import { Layout } from '../../primitives/layout';
export var ToggleList = function (props) {
    var classNames = namespacedClassnames(compKey, props.className);
    var title = React.createElement(Text, { type: 't', color: 't30' }, props.title);
    var toggleList = props.toggles.map(function (toggle, idx) { return (React.createElement(Layout, { key: idx, className: 'toggle-list-item', gap: '8', orientation: 'horizontal' },
        React.createElement(Toggle, { value: toggle.value, onChange: toggle.onChange }),
        React.createElement(Text, { className: 'toggle-text', type: 't', color: 't30' }, toggle.text),
        toggle.tooltipText ? React.createElement(InfoTooltip, { className: 'toggle-info-tooltip', tooltipAlign: 'left', text: toggle.tooltipText, relativeToBody: true }) : null)); });
    return (React.createElement("div", { className: classNames },
        React.createElement(Layout, { gap: '24', orientation: 'horizontal' },
            title,
            toggleList)));
};
//# sourceMappingURL=index.js.map